import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { addToBreadCrumpData, popBreadCrumpData, findPrevPathFromBreadCrumpData } from "../../../config/utils";
import ConfirmationModal from "./ConfirmationModal";
import EditHistory from "../../region/components/EditHistory";
import Portal from "./Portal";
import ShowHelperModal from "../../helper/components/ShowHelperModal";
import { RichEditorPopup } from "./formFields/RichEditorPopup";
import { AssetMainTab } from "../../assets/components/AssetMainTab";
import AssetFieldVisibilityModal from "../../assets/fieldVisibility/AssetFieldVisibilityModal";
import { connect } from "react-redux";
import qs from "query-string";
import actions from "../../assets/actions";
import { getCapitalRequestLabel } from "../../../utils/capitalRequestLabel";
import {
    getRequiredAssetViewFieldKeys,
    resolveAssetViewFieldConfig,
    recomputeAssetViewFieldConfig,
    revalidateAssetViewFieldConfig,
    saveAssetViewFieldConfig,
    resetAssetViewFieldConfig,
    isAssetViewFieldConfigChanged,
    enforceRequiredFieldVisibility,
    getHiddenAssetViewFieldCount,
    bootstrapAssetViewFieldConfig,
    getDynamicBandsSignature
} from "../../assets/fieldVisibility/assetViewFieldConfigUtils";
import { hasStoredAssetViewTableSettings, buildAssetViewFieldCacheKey } from "../../assets/fieldVisibility/assetViewFieldConfigCache";
import { alignAssetViewFieldConfigOrder } from "../../assets/fieldVisibility/assetViewFieldConfig";
import "../../building/fieldVisibility/fieldVisibilityButton.css";
class BasicDetails extends Component {
    state = {
        isHistoryView: false,
        showConfirmModalLog: false,
        selectedLog: "",
        logChanges: {},
        showHelperModal: false,
        selectedHelperItem: {},
        showConfirmModal: false,
        selectedBudgetPriorityData: false,
        showImageModal: false,
        selectedFMP: false,
        showFMPConfirmModal: false,
        showIrConfirmModal: false,
        selectedIr: false,
        showRLConfirmModal: false,
        selectedRL: false,
        showContinuousFCAConfirmModal: false,
        selectedContinuousFCA: false,
        showRichTextPopup: { label: "", key: "", show: false, value: "" },
        basicDetails: {},
        assetViewFieldConfig: null,
        initialAssetViewFieldConfig: null,
        showFieldVisibilityModal: false,
        fieldConfigReady: false
    };

    componentDidMount = async () => {
        if (this.props.basicDetails?.asset?.id) {
            await this.refreshinfoDetails(this.props.basicDetails?.asset?.id);
        }
        if (this.getFieldConfigContext().clientId) {
            this.loadAssetViewFieldSettings();
        }
    };

    componentDidUpdate = async (prevProps, prevState) => {
        const prevAssetId = prevProps.basicDetails?.asset?.id;
        const currentAssetId = this.props.basicDetails?.asset?.id;
        if (prevAssetId !== currentAssetId && currentAssetId) {
            await this.refreshinfoDetails();
        }
        const prevClientId = this.resolveClientId(prevProps, prevState);
        const nextClientId = this.getFieldConfigContext().clientId;
        const prevBandsSignature = getDynamicBandsSignature(prevProps.assetReducer?.assetDynamicFields?.asset_custom_field);
        const nextBandsSignature = getDynamicBandsSignature(this.props.assetReducer?.assetDynamicFields?.asset_custom_field);
        if (nextClientId && prevClientId !== nextClientId) {
            this.loadAssetViewFieldSettings({ refetch: !!prevClientId });
        } else if (nextClientId && prevBandsSignature !== nextBandsSignature) {
            this.recomputeFieldConfigFromCache();
        } else if (!nextClientId && !this.state.fieldConfigReady && this.state.basicDetails?.id) {
            // asset loaded but carries no client, so fall back to showing every field
            this.applyFieldConfigState(bootstrapAssetViewFieldConfig(this.getFieldConfigContext().dynamicBands, "view"));
        }
    };

    resolveClientId = (props = this.props, state = this.state) => {
        const query = qs.parse(props.location?.search || "");
        return state?.basicDetails?.client?.id || props.basicDetails?.client?.id || query.client_id || query.c_id || "";
    };

    getFieldConfigContext = () => {
        const clientId = this.resolveClientId();
        const dynamicBands = this.props.assetReducer?.assetDynamicFields?.asset_custom_field || {};
        const role = localStorage.getItem("role") || "";
        return { role, clientId, dynamicBands, assetState: this.state.basicDetails || {} };
    };

    isFieldVisibilityEditable = () => (localStorage.getItem("role") || "") === "super_admin";

    canCustomizeFields = () => this.isFieldVisibilityEditable() && !!this.getFieldConfigContext().clientId;

    applyFieldConfigState = fieldConfig => {
        this.setState({ assetViewFieldConfig: fieldConfig, initialAssetViewFieldConfig: fieldConfig, fieldConfigReady: true });
    };

    recomputeFieldConfigFromCache = () => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) return;
        this.applyFieldConfigState(recomputeAssetViewFieldConfig({ clientId, dynamicBands, role, assetState, layoutContext: "view" }));
    };

    revalidateFieldConfig = async () => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) return;
        try {
            const fieldConfig = await revalidateAssetViewFieldConfig({ clientId, dynamicBands, role, assetState, layoutContext: "view" });
            if (fieldConfig && this.resolveClientId() === clientId) {
                this.applyFieldConfigState(fieldConfig);
            }
        } catch (_e) {
            // keep the cached config when revalidation fails
        }
    };

    loadAssetViewFieldSettings = async ({ refetch = false } = {}) => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) {
            this.applyFieldConfigState(bootstrapAssetViewFieldConfig(dynamicBands, "view"));
            return;
        }
        if (!refetch && hasStoredAssetViewTableSettings(buildAssetViewFieldCacheKey({ clientId }))) {
            this.recomputeFieldConfigFromCache();
            this.revalidateFieldConfig();
            return;
        }
        this.setState({ fieldConfigReady: false });
        try {
            const { fieldConfig } = await resolveAssetViewFieldConfig({
                clientId,
                dynamicBands,
                role,
                assetState,
                layoutContext: "view",
                refetch: true
            });
            this.applyFieldConfigState(fieldConfig);
        } catch (_e) {
            this.setState({ fieldConfigReady: true });
        }
    };

    openFieldVisibilityModal = () => {
        if (!this.canCustomizeFields()) return;
        this.recomputeFieldConfigFromCache();
        this.setState({ showFieldVisibilityModal: true });
    };

    applyFieldVisibility = async fieldConfig => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        const requiredKeys = getRequiredAssetViewFieldKeys(role, assetState, dynamicBands);
        const enforced = alignAssetViewFieldConfigOrder(enforceRequiredFieldVisibility(fieldConfig, requiredKeys), dynamicBands, "view");
        if (clientId) {
            await saveAssetViewFieldConfig({ clientId, keys: enforced.keys, config: enforced.config, dynamicBands });
        }
        this.setState({ assetViewFieldConfig: enforced, initialAssetViewFieldConfig: enforced });
    };

    resetFieldVisibility = async () => {
        const { role, clientId, dynamicBands, assetState } = this.getFieldConfigContext();
        if (!clientId) return;
        await resetAssetViewFieldConfig({ clientId });
        const { fieldConfig } = await resolveAssetViewFieldConfig({
            clientId,
            dynamicBands,
            role,
            assetState,
            layoutContext: "view",
            refetch: false
        });
        this.setState({
            assetViewFieldConfig: fieldConfig,
            initialAssetViewFieldConfig: fieldConfig,
            showFieldVisibilityModal: false
        });
    };

    isFieldConfigChanged = () => isAssetViewFieldConfigChanged(this.state.assetViewFieldConfig, this.state.initialAssetViewFieldConfig);

    renderFieldVisibilityEyeButton = () => {
        if (!this.isFieldVisibilityEditable()) return null;
        const hiddenFieldCount = getHiddenAssetViewFieldCount(this.state.assetViewFieldConfig);
        const hasHiddenFields = hiddenFieldCount > 0;
        return (
            <span
                className={`edit-icn-bx icon-btn-sec view building-field-visibility-btn building-field-visibility-btn--view${
                    this.canCustomizeFields() ? "" : " cursor-diabled"
                }${hasHiddenFields ? " building-field-visibility-btn--active" : ""}`}
                onClick={() => this.canCustomizeFields() && this.openFieldVisibilityModal()}
                data-tip={
                    this.canCustomizeFields()
                        ? hasHiddenFields
                            ? `${hiddenFieldCount} field(s) hidden — show / hide fields`
                            : "Show / hide fields"
                        : "Select a client context to customize fields"
                }
                data-for="recommandation_Asset"
                data-place="bottom"
            >
                <img src="/img/eye-ico.svg" alt="" className="eye-ico" />
                {hasHiddenFields ? (
                    <i className="fas fa-exclamation-circle building-field-visibility-active-indicator" aria-hidden="true" />
                ) : null}
            </span>
        );
    };

    renderFieldVisibilityModal = () => {
        if (!this.state.showFieldVisibilityModal || !this.state.assetViewFieldConfig) return null;
        const { role, dynamicBands, assetState } = this.getFieldConfigContext();
        const requiredKeys = getRequiredAssetViewFieldKeys(role, assetState, dynamicBands);
        return (
            <Portal
                body={
                    <AssetFieldVisibilityModal
                        key={getDynamicBandsSignature(dynamicBands)}
                        fieldConfig={this.state.assetViewFieldConfig}
                        requiredKeys={requiredKeys}
                        showReset={this.isFieldConfigChanged()}
                        onReset={this.resetFieldVisibility}
                        onApply={this.applyFieldVisibility}
                        onCancel={() => this.setState({ showFieldVisibilityModal: false })}
                    />
                }
                onCancel={() => this.setState({ showFieldVisibilityModal: false })}
            />
        );
    };

    refreshinfoDetails = async () => {
        this.props.getAllImages(this.props.basicDetails?.asset?.id, { limit: 100, offset: 1 });
        this.props.getAssetDynamicFields({
            client_id: this.props.basicDetails.client?.id
        });
        await this.props.getAssetDataById(this.props.basicDetails?.asset?.id);
        const resData = this.props.assetReducer.getDataByIdResponse;
        if (resData && resData.success) {
            this.setState({
                basicDetails: {
                    id: resData.id,
                    code: resData.code,
                    asset_name: resData.asset_name,
                    asset_tag: resData.asset_tag,
                    asset_note: resData.asset_note,
                    client_asset_condition: resData.client_asset_condition,
                    description: resData?.client_asset_condition?.description,
                    installed_year: resData.installed_year,
                    service_life: resData.service_life,
                    usefull_life_remaining: resData.usefull_life_remaining,
                    crv: resData.crv,
                    unit_cost: resData?.unit_cost,
                    energy_use_type: resData?.energy_use_type,
                    manufacturer: resData.manufacturer?.name,
                    model_number: resData.model_number,
                    serial_number: resData.serial_number,
                    core_model_number: resData.core_model_number,
                    capacity: resData.capacity,
                    capacity_unit: resData.capacity_unit,
                    area_served: resData.area_served,
                    client: resData.client,
                    region: resData.region,
                    site: resData.site,
                    building: resData.building,
                    building_type: resData.building_type,
                    addition: resData.addition,
                    floor: resData.floor,
                    room_number: resData.room_number,
                    room_name: resData.room_name,
                    architectural_room_number: resData.architectural_room_number,
                    additional_room_description: resData.additional_room_description,
                    uniformat_level_1: resData.uniformat_level_1,
                    uniformat_level_2: resData.uniformat_level_2,
                    uniformat_level_3: resData.uniformat_level_3,
                    uniformat_level_4: resData.uniformat_level_4,
                    uniformat_level_5: resData.uniformat_level_5,
                    uniformat_level_6: resData.uniformat_level_6,
                    client_standards: resData.client_standards,
                    uniformat_level_6_description: resData.uniformat_level_6_description,
                    asset_type: resData.asset_type,
                    asset_description: resData.asset_description,
                    asset_barcode: resData.asset_barcode,
                    asset_client_id: resData.asset_client_id,
                    asset_cmms_id: resData.asset_cmms_id,
                    warranty_start: resData.warranty_start,
                    warranty_end: resData.warranty_end,
                    install_date: resData.install_date,
                    startup_date: resData.startup_date,
                    upstream_asset_barcode_number: resData.upstream_asset_barcode_number,
                    linked_asset_barcode_number: resData.linked_asset_barcode_number,
                    source_panel_barcode_number: resData.source_panel_barcode_number,
                    source_panel: resData.source_panel,
                    asset_status: resData.asset_status,
                    status: resData.status,
                    notes: resData.notes,
                    created_at: resData.created_at,
                    updated_at: resData.updated_at,
                    image: resData.image,
                    location: resData.location,
                    criticality: resData.criticality,
                    year_manufactured: resData.year_manufactured,
                    guid: resData.guid,
                    skysite_hyperlink: resData.skysite_hyperlink,
                    source_panel_name: resData.source_panel_name,
                    main_category: resData.main_category,
                    sub_category_1: resData.sub_category_1,
                    sub_category_2: resData.sub_category_2,
                    sub_category_3: resData.sub_category_3,
                    subcategory2_description: resData?.sub_category_2?.subcategory2_description,
                    trade: resData.trade,
                    system: resData.system,
                    sub_system: resData.sub_system,
                    quantity: resData.quantity,
                    rtls_tag: resData?.rtls_tag,
                    latitude: resData?.latitude,
                    longitude: resData?.longitude,
                    current_age: resData?.current_age,
                    age: resData?.age,
                    new_asset: resData?.new_asset,
                    source: resData?.source,
                    latest_source: resData?.latest_source,
                    parent_global_id: resData?.parent_global_id,
                    survey_global_id: resData?.survey_global_id,
                    survey_id: resData?.survey_id,
                    survey_property_note: resData?.survey_property_note,
                    capacity_status: resData?.capacity_status,
                    installed_year_status: resData?.installed_year_status,
                    name_plate_status: resData?.name_plate_status,
                    qa_notes: resData?.qa_notes,
                    additional_qa_notes: resData?.additional_qa_notes,
                    surveyor: resData?.surveyor,
                    editor: resData?.editor,
                    survey_date_created: resData?.survey_date_created,
                    survey_date_edited: resData?.survey_date_edited,
                    refrigerant: resData?.refrigerant,
                    fca_cost: resData?.fca_cost,
                    csp_unit: resData?.csp_unit,
                    asset_ownership: resData?.asset_ownership,
                    uniformat_level_3_custom_description: resData?.uniformat_level_3_custom_description,
                    discharge: resData?.asset_additional?.discharge,
                    return: resData?.asset_additional?.return,
                    unit_property_labeled: resData?.asset_additional?.unit_property_labeled,
                    factory_mounted_disconnect: resData?.asset_additional?.factory_mounted_disconnect,
                    unit_voltage: resData?.asset_additional?.unit_voltage,
                    ahu_voltage: resData?.asset_additional?.ahu_voltage,
                    wire_type: resData?.asset_additional?.wire_type,
                    wire_size: resData?.asset_additional?.wire_size,
                    estimated_wire_run_length: resData?.asset_additional?.estimated_wire_run_length,
                    breaker_size: resData?.asset_additional?.breaker_size,
                    mocp: resData?.asset_additional?.mocp,
                    mca: resData?.asset_additional?.mca,
                    liquid_line: resData?.asset_additional?.liquid_line,
                    suction_line: resData?.asset_additional?.suction_line,
                    hot_gas_by_pass: resData?.asset_additional?.hot_gas_by_pass,
                    number_of_circuits: resData?.asset_additional?.number_of_circuits,
                    length_of_line: resData?.asset_additional?.length_of_line,
                    damper_type: resData?.asset_additional?.damper_type,
                    gas_heating: resData?.asset_additional?.gas_heating,
                    gas_output_btu: resData?.asset_additional?.gas_output_btu,
                    electric_heating: resData?.asset_additional?.electric_heating,
                    electric_heating_kw: resData?.asset_additional?.electric_heating_kw,
                    pump_backup_heat_kw: resData?.asset_additional?.pump_backup_heat_kw,
                    cooling_only: resData?.asset_additional?.cooling_only,
                    controls: resData?.asset_additional?.controls,
                    control_type: resData?.asset_additional?.control_type,
                    smoke_detector: resData?.asset_additional?.smoke_detector,
                    smoke_detector_mounting: resData?.asset_additional?.smoke_detector_mounting,
                    smoke_detector_supply: resData?.asset_additional?.smoke_detector_supply,
                    smoke_detector_return: resData?.asset_additional?.smoke_detector_return,
                    curb: resData?.asset_additional?.curb,
                    curb_description: resData?.asset_additional?.curb_description,
                    vibration_isolation: resData?.asset_additional?.vibration_isolation,
                    burglar_bars: resData?.asset_additional?.burglar_bars,
                    installed_on_adapter_curb: resData?.asset_additional?.installed_on_adapter_curb,
                    curb_outside_dimension_length: resData?.asset_additional?.curb_outside_dimension_length,
                    curb_outside_dimension_width: resData?.asset_additional?.curb_outside_dimension_width,
                    allow_curb_adaptor: resData?.asset_additional?.allow_curb_adaptor,
                    ducted_or_concentric_system: resData?.asset_additional?.ducted_or_concentric_system,
                    unit_weight: resData?.asset_additional?.unit_weight,
                    codes_for_disconnects: resData?.asset_additional?.codes_for_disconnects,
                    codes_for_convenience_outlets: resData?.asset_additional?.codes_for_convenience_outlets,
                    codes_for_roof_lighting: resData?.asset_additional?.codes_for_roof_lighting,
                    duct_work_attached_to_bottom_of_unit: resData?.asset_additional?.duct_work_attached_to_bottom_of_unit,
                    aluminium_wire_used: resData?.asset_additional?.aluminium_wire_used,
                    code_or_safety_concerns: resData?.asset_additional?.code_or_safety_concerns,
                    distance_from_salt_water_body: resData?.asset_additional?.distance_from_salt_water_body,
                    recommend_coil_coating: resData?.asset_additional?.recommend_coil_coating,
                    need_resealed: resData?.asset_additional?.need_resealed,
                    split_system_line_sets_good_condition: resData?.asset_additional?.split_system_line_sets_good_condition,
                    split_system_line_sets_damaged: resData?.asset_additional?.split_system_line_sets_damaged,
                    split_system_line_sets_crimped: resData?.asset_additional?.split_system_line_sets_crimped,
                    split_system_line_sets_insulated: resData?.asset_additional?.split_system_line_sets_insulated,
                    split_system_line_sets_re_used: resData?.asset_additional?.split_system_line_sets_re_used,
                    line_connection_type: resData?.asset_additional?.line_connection_type,
                    boiler_type: resData?.asset_additional?.boiler_type,
                    boiler_burner_type: resData?.asset_additional?.boiler_burner_type,
                    boiler_btu_input: resData?.asset_additional?.boiler_btu_input,
                    boiler_btu_output: resData?.asset_additional?.boiler_btu_output,
                    boiler_hp: resData?.asset_additional?.boiler_hp,
                    boiler_fuel: resData?.asset_additional?.boiler_fuel,
                    boiler_gas_pressure: resData?.asset_additional?.boiler_gas_pressure,
                    boiler_kw_input: resData?.asset_additional?.boiler_kw_input,
                    boiler_power_burner_type: resData?.asset_additional?.boiler_power_burner_type,
                    boiler_burner_model: resData?.asset_additional?.boiler_burner_model,
                    boiler_burner_serial: resData?.asset_additional?.boiler_burner_serial,
                    boiler_pressure_type: resData?.asset_additional?.boiler_pressure_type,
                    confirm_boiler_pressure: resData?.asset_additional?.confirm_boiler_pressure,
                    auxiliary: resData.auxiliary,
                    dynamic_fields: resData?.dynamic_fields,
                    locked: resData?.locked
                }
            });
        }
        return true;
    };

    setToolTip(basicDetails, name, className) {
        return (
            <div
                className={`txt-rcm ${name === "Installed Year" ? "wid-tw-rcm" : ""} ${className ? "" : "col-md-3 basic-box"}`}
                data-tip={basicDetails && basicDetails.length > 20 ? basicDetails || "" : ""}
                data-multiline={true}
                data-place="left"
                data-effect="solid"
                data-background-color="#007bff"
                data-for="recommandation_Asset"
            >
                <div className={`${className ? "txt-dtl" : "content-block-card"}`}>
                    <h4 className="m-label">{name}</h4>
                    <h3 className="m-details mt-2">
                        {basicDetails && basicDetails.length > 20 ? basicDetails.substring(0, 20) + "..." : basicDetails || "-"}
                    </h3>
                </div>
            </div>
        );
    }

    handleRestoreLog = async (id, choice, changes) => {
        await this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            logChanges: changes
        });
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, logChanges } = this.state;
        if (!showConfirmModalLog) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to restore this log?"}
                        message={logChanges}
                        onNo={() => this.setState({ showConfirmModalLog: false })}
                        onYes={this.restoreLogOnConfirm}
                        isRestore={true}
                        type={"restore"}
                        isLogChange={true}
                    />
                }
                onCancel={() => this.setState({ showConfirmModalLog: false })}
            />
        );
    };

    restoreLogOnConfirm = async () => {
        const { selectedLog } = this.state;
        await this.props.HandleRestoreSettingsLog(selectedLog);
        await this.props.refreshinfoDetails();
        // await this.getLogData(this.props.match.params.id)
        // await this.props.getMenuItems();
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null,
            isHistoryView: !this.state.isHistoryView
        });
    };

    renderRichTextPopup = () => {
        const { label, key, show, value } = this.state.showRichTextPopup;
        if (!show) return null;
        return (
            <Portal
                body={<RichEditorPopup value={value} label={label} key={key} onCancel={() => this.setState({ showRichTextPopup: {} })} isReadOnly />}
                onCancel={() => this.setState({ showRichTextPopup: null })}
            />
        );
    };

    showHelperModal = async (item, subItem) => {
        await this.setState({
            showHelperModal: true,
            selectedHelperItem: {
                item,
                subItem
            }
        });
    };

    renderUploadHelperModal = () => {
        const { showHelperModal, selectedHelperItem } = this.state;
        if (!showHelperModal) return null;
        return (
            <Portal
                body={<ShowHelperModal selectedHelperItem={selectedHelperItem} onCancel={() => this.setState({ showHelperModal: false })} />}
                onCancel={() => this.setState({ showHelperModal: false })}
            />
        );
    };

    findPriorityText = (element, options) => {
        let text = "-";
        let priorityObj = options.find(option => parseInt(option.value) === element);
        if (priorityObj) {
            text = priorityObj.name;
        }
        return text;
    };

    updateBudgetPriority = () => {
        const { selectedBudgetPriorityData } = this.state;
        this.setState({ showConfirmModal: false });
        this.props.updateBudget({ budget_priority: selectedBudgetPriorityData ? "yes" : "no" }, this.props.match.params.id);
    };

    updateFMP = () => {
        const { selectedFMP } = this.state;
        this.setState({ showFMPConfirmModal: false });
        this.props.updateFMP({ fmp: selectedFMP ? "yes" : "no" }, this.props.match.params.id);
    };
    updateIr = () => {
        const { selectedIr } = this.state;
        this.setState({ showIrConfirmModal: false });
        this.props.updateIR({ infrastructure_request: selectedIr ? "yes" : "no" }, this.props.match.params.id);
    };
    updateRL = () => {
        const { selectedRL } = this.state;
        this.setState({ showRLConfirmModal: false });
        this.props.updateRL({ red_line: selectedRL ? "yes" : "no" }, this.props.match.params.id);
    };

    updateContinuousFCA = () => {
        const { selectedContinuousFCA } = this.state;
        this.setState({ showContinuousFCAConfirmModal: false });
        this.props.updateContinuousFCA({ continuous_fca: selectedContinuousFCA ? "yes" : "no" }, this.props.match.params.id);
    };

    showConfirmation = e => {
        this.setState({ showConfirmModal: true, selectedBudgetPriorityData: e.target.checked });
    };

    showFMPConfirmation = e => {
        this.setState({ showFMPConfirmModal: true, selectedFMP: e.target.checked });
    };
    showIrConfirmation = e => {
        this.setState({ showIrConfirmModal: true, selectedIr: e.target.checked });
    };

    showRLConfirmation = e => {
        this.setState({ showRLConfirmModal: true, selectedRL: e.target.checked });
    };

    showContinuousFCAConfirmation = e => {
        this.setState({ showContinuousFCAConfirmModal: true, selectedContinuousFCA: e.target.checked });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, selectedBudgetPriorityData } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedBudgetPriorityData === false
                                ? "Do you want to remove from Budget Priority?"
                                : "Do you want to add to Budget Priority "
                        }
                        // message={"This action cannot be reverted, are you sure ?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.updateBudgetPriority}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    renderFMPConfirmationModal = () => {
        const { showFMPConfirmModal, selectedFMP } = this.state;
        if (!showFMPConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedFMP === false
                                ? "Do you want to remove from Master Facility Plan ?"
                                : "Do you want to add to Master Facility Plan ?"
                        }
                        onNo={() => this.setState({ showFMPConfirmModal: false })}
                        onYes={this.updateFMP}
                    />
                }
                onCancel={() => this.setState({ showFMPConfirmModal: false })}
            />
        );
    };
    renderIrConfirmationModal = () => {
        const { showIrConfirmModal, selectedIr } = this.state;
        if (!showIrConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            selectedIr === false
                                ? "Do you want to remove from Master Facility Plan ?"
                                : "Do you want to add to Master Facility Plan ?"
                        }
                        onNo={() => this.setState({ showIrConfirmModal: false })}
                        onYes={this.updateIr}
                    />
                }
                onCancel={() => this.setState({ showIrConfirmModal: false })}
            />
        );
    };

    renderRLConfirmationModal = () => {
        const { showRLConfirmModal, selectedRL } = this.state;
        if (!showRLConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={selectedRL === false ? "Do you want to remove from Redlining ?" : "Do you want to add to Redlining ?"}
                        onNo={() => this.setState({ showRLConfirmModal: false })}
                        onYes={this.updateRL}
                    />
                }
                onCancel={() => this.setState({ showRLConfirmModal: false })}
            />
        );
    };

    renderContinuousFCAConfirmationModal = () => {
        const { showContinuousFCAConfirmModal, selectedContinuousFCA } = this.state;
        if (!showContinuousFCAConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={selectedContinuousFCA === false ? "Do you want to remove from Continuous FCA ?" : "Do you want to add to Continuous FCA ?"}
                        onNo={() => this.setState({ showContinuousFCAConfirmModal: false })}
                        onYes={this.updateContinuousFCA}
                    />
                }
                onCancel={() => this.setState({ showContinuousFCAConfirmModal: false })}
            />
        );
    };

    openImageModal = () => {
        this.setState({
            showImageModal: true
        });
    };

    getBandId = band => {
        return band.replace("/", "").split(" ").join("_");
    };

    render() {
        const {
            basicDetails,
            getAllSettingsLogs,
            logData,
            handlePerPageChangeHistory,
            handlePageClickHistory,
            handleGlobalSearchHistory,
            globalSearchKeyHistory,
            handleDeleteLog,
            historyPaginationParams,
            historyParams,
            permissions,
            logPermission,
            isNarrativeRecommendation,
            closeInfoPage,
            hasDelete = true,
            hasEdit = true,
            hasLogView = true,
            hasLogDelete = true,
            hasLogRestore = true,
            hasInfoPage = true
        } = this.props;
        const {
            assetReducer: { getAllImagesResponse }
        } = this.props;
        const dynamicBands = this.props.assetReducer.assetDynamicFields?.asset_custom_field;

        const { isHistoryView, basicDetails: assetBasicDetails, assetViewFieldConfig, fieldConfigReady } = this.state;
        const is_infrastructure_request_user = localStorage.getItem("infrastructure_request_user") === "yes" ? true : false;
        const is_fmp_user = localStorage.getItem("fmp_user") === "yes" ? true : false;
        const crLabel = getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous);

        return (
            <React.Fragment>
                <ReactTooltip id="recommandation_Asset" effect="solid" className="rc-tooltip-custom-class" backgroundColor="#007bff" />
                <div className="tab-active location-sec recom-sec add-recommendation asset-viewer-outer">
                    <div className="recom-top-nav-sec">
                        <div className="check-area-top mr-3">
                            <label htmlFor="">
                                <span className="label-txt"> ID:</span> <span className="label-detl">{basicDetails.code || "-"}</span>{" "}
                            </label>
                            {!this.props.isSurveyView && (
                                <label htmlFor="">
                                    <span className="label-txt"> Type: </span>
                                    <span className="label-detl">
                                        {basicDetails.recommendation_type
                                            ? basicDetails.recommendation_type?.charAt(0)?.toUpperCase() + basicDetails.recommendation_type?.slice(1)
                                            : "-"}
                                    </span>
                                </label>
                            )}
                        </div>
                        <div className="otr-edit-delte text-right ed-dl d-flex align-items-center view-narrative-report">
                            {!this.props.isSurveyView && (
                                <>
                                    {" "}
                                    <div className="budget-pr mr-2">
                                        <label class={`container-check ${basicDetails?.locked ? "cursor-diabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                disabled={basicDetails?.locked}
                                                checked={basicDetails.red_line === "yes" ? true : false}
                                                onChange={this.showRLConfirmation}
                                            ></input>
                                            <span class="checkmark"></span>Redlining
                                        </label>
                                    </div>
                                    <div className="budget-pr mr-2">
                                        <label class={`container-check ${basicDetails?.locked ? "cursor-diabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                disabled={basicDetails?.locked}
                                                checked={basicDetails.continuous_fca === "yes" ? true : false}
                                                onChange={this.showContinuousFCAConfirmation}
                                            ></input>
                                            <span class="checkmark"></span>Continuous FCA
                                        </label>
                                    </div>
                                    <div className="budget-pr mr-2">
                                        <label
                                            class={`container-check ${
                                                is_infrastructure_request_user || basicDetails?.locked ? "cursor-diabled" : ""
                                            }`}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={basicDetails.infrastructure_request === "yes" ? true : false}
                                                onChange={this.showIrConfirmation}
                                                disabled={is_infrastructure_request_user || basicDetails?.locked}
                                            ></input>
                                            <span class="checkmark"></span>{crLabel}
                                        </label>
                                    </div>
                                    <div className="budget-pr mr-3">
                                        <label class={`container-check ${basicDetails?.locked ? "cursor-diabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                disabled={basicDetails?.locked}
                                                checked={basicDetails.budget_priority === "yes" ? true : false}
                                                onChange={this.showConfirmation}
                                            ></input>
                                            <span class="checkmark"></span>Budget Priority
                                        </label>
                                    </div>
                                    <div className="budget-pr mr-3">
                                        <label class={`container-check ${is_fmp_user || basicDetails?.locked ? "cursor-diabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                disabled={is_fmp_user || basicDetails?.locked}
                                                checked={basicDetails.fmp === "yes" ? true : false}
                                                onChange={this.showFMPConfirmation}
                                            ></input>
                                            <span class="checkmark"></span>Master Facility Plan
                                        </label>
                                    </div>
                                </>
                            )}
                            <div className="reco-main-icon-link">
                                {!isHistoryView && this.renderFieldVisibilityEyeButton()}
                                {isNarrativeRecommendation ? (
                                    <>
                                        {/* <span
                                        onClick={() => {
                                            this.props.downloadPdfReport({
                                                project_id: basicDetails?.project?.id,
                                                building_id: basicDetails?.building?.id,
                                                subsystem_id: basicDetails?.sub_system?.id
                                            });
                                        }}
                                        className="edit-icn-bx icon-btn-sec"
                                        data-tip=" View Narrative Report"
                                        data-for="recommandation_Asset"
                                        data-place="top"
                                    >
                                        <img src="/img/narrative-rec.svg" alt="" />
                                    </span> */}
                                        <span
                                            onClick={closeInfoPage}
                                            className="edit-icn-bx icon-btn-sec"
                                            data-tip="Close"
                                            data-for="recommandation_Asset"
                                            data-place="top"
                                        >
                                            <img src="/img/close-rec.svg" alt="" />
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        {/* <span
                                        onClick={() => {
                                            this.props.downloadPdfReport({
                                                project_id: basicDetails?.project?.id,
                                                building_id: basicDetails?.building?.id,
                                                subsystem_id: basicDetails?.sub_system?.id
                                            });
                                        }}
                                        className="edit-icn-bx icon-btn-sec"
                                        data-tip=" View Narrative Report"
                                        data-for="recommandation_Asset"
                                        data-place="top"
                                    >
                                        <img src="/img/narrative-rec.svg" alt="" />
                                    </span> */}
                                        {basicDetails && basicDetails.locked === true
                                            ? ""
                                            : hasLogView && (
                                                  <span
                                                      onClick={() => {
                                                          this.setState({ isHistoryView: !this.state.isHistoryView });
                                                      }}
                                                      className="edit-icn-bx icon-btn-sec"
                                                      data-tip={isHistoryView ? "View Details" : "View History"}
                                                      data-for="recommandation_Asset"
                                                      data-place="top"
                                                  >
                                                      <img src="/img/history-rec.svg" alt="" />
                                                  </span>
                                              )}
                                        <span
                                            onClick={() => {
                                                popBreadCrumpData();
                                                popBreadCrumpData();
                                                this.props.history.push(findPrevPathFromBreadCrumpData());
                                            }}
                                            className="edit-icn-bx icon-btn-sec"
                                            data-tip="Close"
                                            data-for="recommandation_Asset"
                                            data-place="top"
                                        >
                                            <img src="/img/close-rec.svg" alt="" />
                                        </span>
                                        {basicDetails && basicDetails.locked === true ? (
                                            ""
                                        ) : (
                                            <>
                                                {!basicDetails.deleted
                                                    ? hasEdit && (
                                                          <span
                                                              className="edit-icn-bx icon-btn-sec"
                                                              onClick={() => {
                                                                  addToBreadCrumpData({
                                                                      key: "edit",
                                                                      name: `Edit ${this.props.location.pathname.split("/")[1]}`,
                                                                      path: `/${this.props.location.pathname.split("/")[1]}/edit/${
                                                                          this.props.match.params.id
                                                                      }?p_id=${basicDetails?.project?.id}&c_id=${
                                                                          basicDetails?.client?.id
                                                                      }&active_tab=asset`
                                                                  });
                                                                  this.props.history.push(
                                                                      `/${this.props.location.pathname.split("/")[1]}/edit/${
                                                                          this.props.match.params.id
                                                                      }?p_id=${basicDetails?.project?.id}&c_id=${
                                                                          basicDetails?.client?.id
                                                                      }&active_tab=asset`
                                                                  );
                                                              }}
                                                              data-tip="Edit"
                                                              data-for="recommandation_Asset"
                                                              data-place="top"
                                                          >
                                                              <img src="/img/edit-rec.svg" alt="" />
                                                          </span>
                                                      )
                                                    : hasEdit && (
                                                          <span
                                                              onClick={() => this.props.restoreRecommendation()}
                                                              className="edit-icn-bx icon-btn-sec"
                                                              data-tip="Restore"
                                                              data-for="recommandation_Asset"
                                                              data-place="top"
                                                          >
                                                              <img src="/img/restore-reco.svg" alt="" />
                                                          </span>
                                                      )}
                                                {hasDelete && (
                                                    <span
                                                        className="edit-icn-bx icon-btn-sec del"
                                                        onClick={() => this.props.deleteRecommendation(basicDetails.deleted || false)}
                                                        data-tip="Delete"
                                                        data-for="recommandation_Asset"
                                                        data-place="top"
                                                    >
                                                        <img src="/img/delete-icon.svg" alt="" />
                                                    </span>
                                                )}

                                                <span
                                                    className="view-inner help-icon"
                                                    data-tip={`Help`}
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-background-color="#007bff"
                                                    onClick={() => {
                                                        this.showHelperModal("forms", "recommendations");
                                                    }}
                                                >
                                                    <img src="/img/question-mark-icon.png" alt="" className="fil-ico" />
                                                </span>
                                                {this.renderUploadHelperModal()}
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {isHistoryView ? (
                        <EditHistory
                            getAllRegionLogs={getAllSettingsLogs}
                            // changeToHistory={this.changeToHistory}
                            handlePerPageChangeHistory={handlePerPageChangeHistory}
                            handlePageClickHistory={handlePageClickHistory}
                            handleGlobalSearchHistory={handleGlobalSearchHistory}
                            globalSearchKeyHistory={globalSearchKeyHistory}
                            logData={logData}
                            handleDeleteLog={handleDeleteLog}
                            historyPaginationParams={historyPaginationParams}
                            isProjectSettings={true}
                            handleRestoreLog={this.handleRestoreLog}
                            historyParams={historyParams}
                            permissions={permissions}
                            logPermission={logPermission}
                            hasLogDelete={hasLogDelete}
                            hasLogRestore={hasLogRestore}
                            hasEdit={hasEdit}
                            hasDelete={hasDelete}
                            hasInfoPage={hasInfoPage}
                        />
                    ) : (
                        <AssetMainTab
                            basicDetails={assetBasicDetails}
                            imageResponse={getAllImagesResponse}
                            dynamicBands={dynamicBands}
                            fieldConfig={assetViewFieldConfig}
                            configReady={fieldConfigReady}
                        />
                    )}

                    {this.renderFieldVisibilityModal()}
                    {this.renderConfirmationModalLog()}
                    {this.renderConfirmationModal()}
                    {this.renderFMPConfirmationModal()}
                    {this.renderIrConfirmationModal()}
                    {this.renderRLConfirmationModal()}
                    {this.renderContinuousFCAConfirmationModal()}
                    {this.renderRichTextPopup()}
                </div>
                {/* <ReactTooltip /> */}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { assetReducer, projectReducer } = state;
    return { assetReducer, projectReducer };
};

export default withRouter(
    connect(mapStateToProps, {
        ...actions
    })(BasicDetails)
);
